import SharedDispatcher from "./SharedDispatcher";

// tmp fix for scripts that should import SharedDispatcher instead of use global property
// ex: Src/www/Legacy/MyFnac/Controls/Newsletter/Preferences.ascx
let warnGlobalAppUsage = true;
window.Fnac = window.Fnac || {};
Object.defineProperty(Fnac, "App", {
  get: () => {
    if(warnGlobalAppUsage){
      console.warn("Use global Fnac.App is depreciated, use 'import SharedDispatcher from \"..../SharedDispatcher\";' instead.");
    }
    warnGlobalAppUsage = false;
    return SharedDispatcher;
  }
});

let warnGlobalSharedDispatcherUsage = true;
Object.defineProperty(window, "SharedDispatcher", {
  get: () => {
    if(warnGlobalSharedDispatcherUsage){
      console.warn("Use global SharedDispatcher is depreciated, use 'import SharedDispatcher from \"..../SharedDispatcher\";' instead.");
    }
    warnGlobalSharedDispatcherUsage = false;
    return SharedDispatcher;
  }
});
